webpackJsonp([77],{

/***/ "+Phd":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'SidebarRight',
    data: function data() {
      return {
        pageOptions: _PageOptions2.default
      };
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "01Oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_874dd30a__ = __webpack_require__("9RM9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js__ = __webpack_require__("HDbo");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_874dd30a__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_874dd30a__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "0Ufk":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("NYxO")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vuex) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'SidebarNavProfile',
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('access', {
      userInfo: function userInfo(state) {
        return state.userInfo;
      }
    })),
    data: function data() {
      return {
        stat: ''
      };
    },

    methods: {
      expand: function expand() {
        this.stat = this.stat === 'expand' ? 'collapse' : 'expand';
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "11/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js__ = __webpack_require__("x4wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNavList_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "2LVM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("uEtF"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _TopMenuNav, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _TopMenuNav2 = _interopRequireDefault(_TopMenuNav);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'TopMenu',
    components: {
      TopMenuNav: _TopMenuNav2.default
    },
    data: function data() {
      return {
        pageOptions: _PageOptions2.default
      };
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "2ofX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/top-menu/TopMenuNav.vue?vue&type=template&id=08db4888
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userInfo.menulist)?_c('ul',{staticClass:"nav",style:({ marginLeft: '-' + _vm.margin.left + 'px', marginRight: '-'+ _vm.margin.right + 'px' })},[_vm._l((_vm.userInfo.menulist),function(menu){return [_c('top-menu-nav-list',{key:menu.menu_name,ref:"topMenuNavList",refInFor:true,attrs:{"menu":menu,"status":menu.status},on:{"collapse-other":function($event){return _vm.handleCollapseOther(menu)}}})]}),_vm._v(" "),_c('li',{staticClass:"menu-control menu-control-left",class:{ 'show': _vm.controls.left },on:{"click":_vm.controlLeft}},[_vm._m(0)]),_vm._v(" "),_c('li',{staticClass:"menu-control menu-control-right",class:{ 'show': _vm.controls.right },on:{"click":_vm.controlRight}},[_vm._m(1)])],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;","data-click":"prev-menu"}},[_c('i',{staticClass:"fa fa-angle-left"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;","data-click":"next-menu"}},[_c('i',{staticClass:"fa fa-angle-right"})])}]


// CONCATENATED MODULE: ./src/components/top-menu/TopMenuNav.vue?vue&type=template&id=08db4888
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "6cy/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6e9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageOptions_vue_vue_type_script_lang_js__ = __webpack_require__("lNZB");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__PageOptions_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__PageOptions_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");
var render, staticRenderFns




/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__PageOptions_vue_vue_type_script_lang_js__["default"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "74aZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js__ = __webpack_require__("ZFgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Panel_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "851q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8EN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ex4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9AdH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hz52.765cb9f.png";

/***/ }),

/***/ "9RM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/Sidebar.vue?vue&type=template&id=874dd30a
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar",class:{ 'sidebar-transparent': _vm.pageOptions.pageSidebarTransparent },attrs:{"id":"sidebar"}},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[_c('sidebar-nav-profile'),_vm._v(" "),_c('sidebar-nav')],1)],1),_vm._v(" "),_c('div',{staticClass:"sidebar-bg"}),_vm._v(" "),_c('div',{staticClass:"mobile-click",on:{"click":_vm.dismissSidebar}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/sidebar/Sidebar.vue?vue&type=template&id=874dd30a
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "Amey":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/map',
    name: 'map',
    meta: {
      login: true
    }
  }, { path: '/map/MapConfigControl', name: 'MapConfigControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fvaf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/flowToSum', name: 'flowToSum', component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lIZu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/OperationBoard', name: 'OperationBoard', component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uvWd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/MapAisConfig', name: 'MapAisConfig', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HC8U")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/VesselConfigControl', name: 'VesselConfigControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZgNo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/TreasureShipData', name: 'TreasureShipData', component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+P7o")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/DifferentialDataProofreading', name: 'DifferentialDataProofreading', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TYnt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/VesselNameControl', name: 'VesselNameControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L38Y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/ErrorLogControl', name: 'ErrorLogControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5Ufc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/ResourceGroupControl', name: 'ResourceGroupControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gMj1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, {
    path: '/map/PortStandardizingControl',
    name: 'PortStandardizingControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xudc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: '/map/RouteReference', name: 'RouteReference', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UC0v")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/CargoForecast', name: 'CargoForecast', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ekrI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, {
    path: '/map/DailyForecastFilling',
    name: 'DailyForecastFilling',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eJVV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/map/ElectronicFence',
    name: 'ElectronicFence',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ev5H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/map/MonthlyForecastFormula',
    name: 'MonthlyForecastFormula',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VizO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/map/PXPredication',
    name: 'PXPredication',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4+ih")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: '/map/VesselPath', name: 'VesselPath', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("001a")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/OpenLink', name: 'OpenLink', component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t/cq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/PortGroupControl', name: 'PortGroupControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2nzB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/cargoFlowtoPredication', name: 'cargoFlowtoPredication', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("udd5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "BMpk":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("NYxO"), __webpack_require__("01Oi"), __webpack_require__("caPX"), __webpack_require__("CaK3"), __webpack_require__("Zeja"), __webpack_require__("bYoP"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vuex, _Sidebar, _SidebarRight, _Header, _TopMenu, _Footer, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _Sidebar2 = _interopRequireDefault(_Sidebar);

  var _SidebarRight2 = _interopRequireDefault(_SidebarRight);

  var _Header2 = _interopRequireDefault(_Header);

  var _TopMenu2 = _interopRequireDefault(_TopMenu);

  var _Footer2 = _interopRequireDefault(_Footer);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'app',
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('access', {
      userInfo: function userInfo(state) {
        return state.userInfo;
      }
    })),
    components: {
      Sidebar: _Sidebar2.default,
      SidebarRight: _SidebarRight2.default,
      Header: _Header2.default,
      TopMenu: _TopMenu2.default,
      Footer: _Footer2.default
    },
    data: function data() {
      return {
        pageOptions: _PageOptions2.default,
        forReload: true
      };
    },

    methods: {
      handleScroll: function handleScroll() {
        _PageOptions2.default.pageBodyScrollTop = window.scrollY;
      },
      refreshRouter: function refreshRouter() {
        var _this = this;

        this.forReload = false;
        this.$nextTick(function () {
          _this.forReload = true;
        });
      }
    },
    mounted: function mounted() {
      this.$insProgress.finish();
    },
    created: function created() {
      var _this2 = this;

      _PageOptions2.default.pageBodyScrollTop = window.scrollY;

      window.addEventListener('scroll', this.handleScroll);

      this.$insProgress.start();

      this.$router.beforeEach(function (to, from, next) {
        _this2.$insProgress.start();
        next();
      });
      this.$router.afterEach(function () {
        _this2.$insProgress.finish();
      });
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "BSYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js__ = __webpack_require__("+Phd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarRight_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "BvLc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CaK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_ffdc75fc__ = __webpack_require__("tObk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js__ = __webpack_require__("rJH2");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_ffdc75fc__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_ffdc75fc__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "Cpzh":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // 命名：模块名+功能
  var ACCESS_LOGIN = exports.ACCESS_LOGIN = 'ACCESS_LOGIN'; // 授权登录
  var ACCESS_LOGOUT = exports.ACCESS_LOGOUT = 'ACCESS_LOGOUT'; // 登出

  var CARGO_SETVC = exports.CARGO_SETVC = 'CARGO_SETVC';
  var CARGO_SETCC = exports.CARGO_SETCC = 'CARGO_SETCC';
  var CARGO_SETPC = exports.CARGO_SETPC = 'CARGO_SETPC';
  var CARGO_SETTC = exports.CARGO_SETTC = 'CARGO_SETTC';

  var PATH_SETVC = exports.PATH_SETVC = 'PATH_SETVC';
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "D3yc":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("NYxO"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vuex, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'Header',
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('access', {
      userInfo: function userInfo(state) {
        return state.userInfo;
      }
    })),
    data: function data() {
      return {
        pageOptions: _PageOptions2.default
      };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('access', ['logout']), {
      toggleMobileSidebar: function toggleMobileSidebar() {
        this.pageOptions.pageMobileSidebarToggled = !this.pageOptions.pageMobileSidebarToggled;
      },
      toggleMobileRightSidebar: function toggleMobileRightSidebar() {
        this.pageOptions.pageMobileRightSidebarToggled = !this.pageOptions.pageMobileRightSidebarToggled;
      },
      toggleMobileTopMenu: function toggleMobileTopMenu() {
        this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu;
      },
      toggleMobileMegaMenu: function toggleMobileMegaMenu() {
        this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu;
      },
      toggleRightSidebar: function toggleRightSidebar() {
        this.pageOptions.pageRightSidebarToggled = !this.pageOptions.pageRightSidebarToggled;
      },

      checkForm: function checkForm(e) {
        e.preventDefault();
        this.$router.push({ path: '/extra/search' });
      },
      dropdownWork: function dropdownWork(name) {
        if (name === 'logout') {
          this.$http.post('/v1/api/node/auth/signout', {});
          this.logout();
          this.$router.push({ path: '/' });
        } else if (name === 'profile') {
          this.$router.push({ path: '/admin/user/UserProfile' });
        }
      }
    })
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "D6JK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js__ = __webpack_require__("rMHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNav_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "D9hb":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("uk7y")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _Panel) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Panel2 = _interopRequireDefault(_Panel);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Panel = {
    install: function install(Vue) {
      Vue.component(_Panel2.default.name, _Panel2.default);
    }
  };

  exports.default = Panel;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "DHpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNavProfile_vue_vue_type_template_id_7d2051fe_scoped_true__ = __webpack_require__("g+ak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavProfile_vue_vue_type_script_lang_js__ = __webpack_require__("ST7e");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SidebarNavProfile_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SidebarNavProfile_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavProfile_vue_vue_type_style_index_0_id_7d2051fe_scoped_true_lang_css__ = __webpack_require__("Qif7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SidebarNavProfile_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNavProfile_vue_vue_type_template_id_7d2051fe_scoped_true__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNavProfile_vue_vue_type_template_id_7d2051fe_scoped_true__["b" /* staticRenderFns */],
  false,
  null,
  "7d2051fe",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "Dp6o":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/empty',
    name: 'empty',
    meta: {
      login: true
    }
  }, { path: '/empty/home', name: 'emptyHome', component: function component(resolve) {
      return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j7e0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/empty/test', name: 'test', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dDHZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "EYnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F7Tt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FjQV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HDbo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js__ = __webpack_require__("r0H6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "Hj8e":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("NYxO"), __webpack_require__("jGjK"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vuex, _TopMenuNavList, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _TopMenuNavList2 = _interopRequireDefault(_TopMenuNavList);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'TopMenuNav',
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('access', {
      userInfo: function userInfo(state) {
        return state.userInfo;
      }
    })),
    components: {
      TopMenuNavList: _TopMenuNavList2.default
    },
    mounted: function mounted() {
      var windowWidth = this.$el.clientWidth - 128;
      var listFullWidth = 0;
      var listPrevWidth = 0;
      var listActive = false;

      document.querySelectorAll('.top-menu .nav > li').forEach(function (elm) {
        listFullWidth += elm.offsetWidth;
        listPrevWidth += !listActive ? elm.offsetWidth : 0;
        listActive = elm.classList.contains('active') ? true : listActive;
      });

      this.nav.width = listFullWidth;

      listPrevWidth = !listActive ? 0 : listPrevWidth;

      if (listPrevWidth >= windowWidth) {
        var finalScrollWidth = listPrevWidth - windowWidth + 128;
        if (!document.body.classList.contains('rtl-mode')) {
          this.margin.left = finalScrollWidth;
          this.margin.right = 0;
        } else {
          this.margin.right = finalScrollWidth;
          this.margin.left = 0;
        }
      }

      this.controls.right = listPrevWidth !== listFullWidth && listFullWidth >= windowWidth ? true : false;
      this.controls.left = listPrevWidth >= windowWidth && listFullWidth >= windowWidth ? true : false;
    },
    data: function data() {
      return {
        pageOptions: _PageOptions2.default,
        controls: {
          left: false,
          right: false
        },
        margin: {
          left: 0,
          right: 0
        },
        nav: {
          width: 0
        }
      };
    },

    methods: {
      handleCollapseOther: function handleCollapseOther(menu) {
        for (var i = 0; i < this.userInfo.menulist.length; i++) {
          this.$refs.topMenuNavList[i].collapse(menu);
        }
      },
      controlRight: function controlRight() {
        var containerWidth = document.querySelector('.top-menu').offsetWidth - 88;
        var widthLeft = this.nav.width + -this.margin.left - containerWidth;
        var finalScrollWidth = 0;

        if (widthLeft <= containerWidth) {
          finalScrollWidth = widthLeft - -this.margin.left + 128;
          this.controls.right = false;
        } else {
          finalScrollWidth = containerWidth - -this.margin.left - 128;
        }

        if (finalScrollWidth !== 0) {
          if (!document.body.classList.contains('rtl-mode')) {
            this.margin.left = finalScrollWidth;
            this.margin.right = 0;
          } else {
            this.margin.right = finalScrollWidth;
            this.margin.left = 0;
          }
          this.controls.left = true;
        }
      },
      controlLeft: function controlLeft() {
        var widthLeft = this.margin.left;
        var containerWidth = document.querySelector('.top-menu').offsetWidth;
        var finalScrollWidth = 0;

        if (widthLeft <= containerWidth) {
          finalScrollWidth = 0;
          this.controls.left = false;
        } else {
          finalScrollWidth = widthLeft - containerWidth + 88;
        }

        if (!document.body.classList.contains('rtl-mode')) {
          this.margin.left = finalScrollWidth;
          this.margin.right = 0;
          this.controls.right = true;
        } else {
          this.margin.right = finalScrollWidth;
          this.margin.left = 0;
          this.controls.right = true;
        }
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("7+uW"), __webpack_require__("NYxO"), __webpack_require__("xm+f"), __webpack_require__("QTf2"), __webpack_require__("Xsvw")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vue, _vuex, _access, _cargoflow, _vesselpath) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _vue2 = _interopRequireDefault(_vue);

  var _vuex2 = _interopRequireDefault(_vuex);

  var _access2 = _interopRequireDefault(_access);

  var _cargoflow2 = _interopRequireDefault(_cargoflow);

  var _vesselpath2 = _interopRequireDefault(_vesselpath);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  _vue2.default.use(_vuex2.default);

  var store = new _vuex2.default.Store({
    modules: {
      access: (0, _extends3.default)({
        namespaced: true
      }, _access2.default),
      cargoflow: (0, _extends3.default)({
        namespaced: true
      }, _cargoflow2.default),
      vesselpath: (0, _extends3.default)({
        namespaced: true
      }, _vesselpath2.default)
    }
  });

  exports.default = store;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "J2uu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("BO1k"), __webpack_require__("Xxa5"), __webpack_require__("exGp"), __webpack_require__("woOf"), __webpack_require__("mvHQ"), __webpack_require__("Av7u"), __webpack_require__("Y4FN")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _getIterator2, _regenerator, _asyncToGenerator2, _assign, _stringify, _cryptoJs, _store) {
  'use strict';

  var _getIterator3 = _interopRequireDefault(_getIterator2);

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _assign2 = _interopRequireDefault(_assign);

  var _stringify2 = _interopRequireDefault(_stringify);

  var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

  var _store2 = _interopRequireDefault(_store);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.convertBase64StrToArray = function (base64Str) {
    var bytes = window.atob(base64Str); // 去掉url的头，并转换为byte
    // 处理异常,将ascii码小于0的转换为大于0
    var ab = new ArrayBuffer(bytes.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }
    return ab;
  };

  exports.aesEncryptModeCFB = function (msg, pwd) {
    var magicNo = exports.generateRandomAlphaNum(32);

    var key = _cryptoJs2.default.enc.Hex.parse(_cryptoJs2.default.MD5(pwd).toString());
    var iv = _cryptoJs2.default.enc.Hex.parse(magicNo);

    var identifyCode = _cryptoJs2.default.AES.encrypt(msg, key, {
      iv: iv,
      mode: _cryptoJs2.default.mode.CBC,
      padding: _cryptoJs2.default.pad.Pkcs7
    }).toString();
    return [magicNo, identifyCode];
  };

  exports.generateRandomAlphaNum = function (len) {
    var rdmString = '';
    // toSting接受的参数表示进制，默认为10进制。36进制为0-9 a-z
    for (; rdmString.length < len;) {
      rdmString += Math.random().toString(16).substr(2);
    }
    return rdmString.substr(0, len);
  };

  exports.clearStoreData = function (key, value) {
    _store2.default.clearAll();
  };

  exports.setStoreData = function (key, value) {
    _store2.default.set(key, value);
  };

  function getStoreData(key) {
    return _store2.default.get(key);
  }
  exports.getStoreData = getStoreData;

  exports.removeStoreData = function (key) {
    _store2.default.remove(key);
  };

  exports.uploadHeaders = function () {
    return {
      Authorization: getStoreData('token')
    };
  };

  exports.treeIconRender = function (h, _ref, _self, treeRef, folderIcon, menuIcon) {
    var root = _ref.root,
        node = _ref.node,
        data = _ref.data;

    if (node.node.node_type === '00') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: folderIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title)])]);
    } else if (node.node.node_type === '01') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: menuIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title)])]);
    }
  };

  exports.treeIconDelRender = function (h, _ref2, _self, treeRef, folderIcon, menuIcon, func) {
    var root = _ref2.root,
        node = _ref2.node,
        data = _ref2.data;

    if (data.systemmenu_id === 0) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: folderIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title)])]);
    } else if (node.node.node_type === '00') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: folderIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '16px'
        }
      }, [h('Button', {
        props: (0, _assign2.default)({}, { type: 'default', size: 'small' }, {
          icon: 'ios-remove'
        }),
        on: {
          click: function click() {
            _self.$commonact.confirm('确认要删除?', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
              return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      func(data);

                    case 1:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, undefined);
            })));
          }
        }
      })])])]);
    } else if (node.node.node_type === '01') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: menuIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '16px'
        }
      }, [h('Button', {
        props: (0, _assign2.default)({}, { type: 'default', size: 'small' }, {
          icon: 'ios-remove'
        }),
        on: {
          click: function click() {
            _self.$commonact.confirm('确认要删除?', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
              return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      func(data);

                    case 1:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, undefined);
            })));
          }
        }
      })])])]);
    }
  };

  exports.treeIconGroupRender = function (h, _ref5, _self, treeRef, folderIcon, menuIcon, func) {
    var root = _ref5.root,
        node = _ref5.node,
        data = _ref5.data;

    if (data.usergroup_id === 0) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: folderIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title)])]);
    } else if (data.name === 'DEFAULT') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: menuIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title)])]);
    } else if (node.node.node_type === '00') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: folderIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '16px'
        }
      }, [h('Button', {
        props: (0, _assign2.default)({}, { type: 'default', size: 'small' }, {
          icon: 'ios-remove'
        }),
        on: {
          click: function click() {
            console.log(data);
            _self.$commonact.confirm('确认要删除?', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
              return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      func(data);

                    case 1:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, undefined);
            })));
          }
        }
      })])])]);
    } else if (node.node.node_type === '01') {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: menuIcon
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', {
        style: {
          color: '#666',
          cursor: 'pointer'
        },
        domProps: {
          className: 'treenode'
        },
        on: {
          click: function click(e) {
            var nodes = treeRef.$el.querySelectorAll('.treenode');
            for (var i = 0; i < nodes.length; i++) {
              nodes[i].style.backgroundColor = '#fff';
            }
            e.currentTarget.style.backgroundColor = '#2d8cf0'; // 当前点击的元素
            _self.actNode = JSON.parse((0, _stringify2.default)(node.node));
          }
        }
      }, data.title), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '16px'
        }
      }, [h('Button', {
        props: (0, _assign2.default)({}, { type: 'default', size: 'small' }, {
          icon: 'ios-remove'
        }),
        on: {
          click: function click() {
            _self.$commonact.confirm('确认要删除?', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
              return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      func(data);

                    case 1:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, undefined);
            })));
          }
        }
      })])])]);
    }
  };
  // exports.selectRender = (_self, key) => {
  //   return (h, params) => {
  //     let options = []
  //     _self.pagePara[key].forEach(item => {
  //       options.push(
  //         h(
  //           'Option',
  //           {
  //             props: {
  //               value: item.id,
  //               key: item.id
  //             }
  //           },
  //           item.text
  //         )
  //       )
  //     })
  //     return h(
  //       'Select',
  //       {
  //         props: {
  //           value: params.row[params.column.key],
  //           disabled: true
  //         }
  //       },
  //       options
  //     )
  //   }
  // }

  // 因为效率问题
  exports.selectRender = function (_self, key) {
    return function (h, params) {
      var text = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(_self.pagePara[key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.id === params.row[params.column.key]) {
            text = item.text;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return h('span', {}, text);
    };
  };

  var tooltipFormat = function tooltipFormat(value) {
    if (value.length > 8) {
      return value.substring(0, 5) + '...';
    } else {
      return value;
    }
  };

  exports.tooltipRender = function () {
    return function (h, params) {
      return h('Tooltip', {
        props: {
          trigger: 'hover',
          'max-width': 400,
          content: params.row[params.column.key]
        }
      }, [h('Button', {
        style: 'text-decoration:underline',
        props: {
          type: 'text'
        }
      }, tooltipFormat(params.row[params.column.key]))]);
    };
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JuyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js__ = __webpack_require__("XSYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "KJwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lci9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__ = __webpack_require__("BMpk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_8ccf484c__ = __webpack_require__("jcqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__ = __webpack_require__("Lci9");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_8ccf484c__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_8ccf484c__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "MFRW":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/admin',
    name: 'admin',
    meta: { login: true }
  }, {
    path: '/admin/auth/SystemApiControl',
    name: 'SystemApiControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hyI5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/OrganizationTemplateControl',
    name: 'OrganizationTemplateControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ULhs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/OrganizationControl',
    name: 'OrganizationControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sRfu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/OrganizationGroupControl',
    name: 'OrganizationGroupControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(69)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Wbrh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/OrganizationUserControl',
    name: 'OrganizationUserControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b1Ae")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/GroupControl',
    name: 'GroupControl',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nQnm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/OperatorControl',
    name: 'OperatorControl',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mqep")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/auth/ResetPassword',
    name: 'ResetPassword',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ifBX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/user/UserProfile',
    name: 'UserProfile',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WLnz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/device/DeviceControl',
    name: 'DeviceControl',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bjHP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("//Fk"), __webpack_require__("7+uW"), __webpack_require__("NYxO"), __webpack_require__("mtWM"), __webpack_require__("IcnI"), __webpack_require__("cWtX"), __webpack_require__("/ocq"), __webpack_require__("CmzC"), __webpack_require__("BTaQ"), __webpack_require__("8/7D"), __webpack_require__("D9hb"), __webpack_require__("J2uu"), __webpack_require__("zL8q"), __webpack_require__("M93x"), __webpack_require__("5eDb"), __webpack_require__("3Oml"), __webpack_require__("Abny"), __webpack_require__("NBEC"), __webpack_require__("HaK5"), __webpack_require__("gBhd"), __webpack_require__("Q/P+"), __webpack_require__("f85y"), __webpack_require__("yXOt"), __webpack_require__("S0tB"), __webpack_require__("axCQ"), __webpack_require__("Jmt5"), __webpack_require__("FjQV"), __webpack_require__("TimX"), __webpack_require__("dlx8"), __webpack_require__("cpFS"), __webpack_require__("+skl"), __webpack_require__("YzDh"), __webpack_require__("EYnv"), __webpack_require__("jU7J"), __webpack_require__("BvLc"), __webpack_require__("VRXO"), __webpack_require__("KJwH"), __webpack_require__("bBfo"), __webpack_require__("Ys3w"), __webpack_require__("hA8f"), __webpack_require__("tvR6"), __webpack_require__("8EN5"), __webpack_require__("hQya"), __webpack_require__("F7Tt"), __webpack_require__("6cy/"), __webpack_require__("8ex4"), __webpack_require__("VaBq"), __webpack_require__("851q")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (_promise, _vue, _vuex, _axios, _store, _router, _vueRouter, _vueInsProgressBar, _iview, _vuescroll, _panel, _common, _elementUi, _App) {
  'use strict';

  var _promise2 = _interopRequireDefault(_promise);

  var _vue2 = _interopRequireDefault(_vue);

  var _vuex2 = _interopRequireDefault(_vuex);

  var _axios2 = _interopRequireDefault(_axios);

  var _store2 = _interopRequireDefault(_store);

  var _router2 = _interopRequireDefault(_router);

  var _vueRouter2 = _interopRequireDefault(_vueRouter);

  var _vueInsProgressBar2 = _interopRequireDefault(_vueInsProgressBar);

  var _iview2 = _interopRequireDefault(_iview);

  var _vuescroll2 = _interopRequireDefault(_vuescroll);

  var _panel2 = _interopRequireDefault(_panel);

  var common = _interopRequireWildcard(_common);

  var _elementUi2 = _interopRequireDefault(_elementUi);

  var _App2 = _interopRequireDefault(_App);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // use mavon-editor


  // TinyMCE自定义样式


  // plugins css


  // plugins
  _vue2.default.use(_vuex2.default);

  // color admin css


  // TinyMCE核心
  // 引入tinymce插件
  // The Vue build version to load with the `import` command
  // (runtime-only or standalone) has been set in webpack.base.conf with an alias.

  _vue2.default.use(_vueRouter2.default);
  _vue2.default.use(_vuescroll2.default);
  _vue2.default.use(_iview2.default);
  _vue2.default.use(_elementUi2.default);
  _vue2.default.use(_panel2.default);
  _vue2.default.use(_vueInsProgressBar2.default, {
    position: 'fixed',
    show: true,
    height: '3px'
  });

  var router = new _vueRouter2.default({
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return { y: 0 };
    },
    routes: _router2.default
  });

  router.beforeEach(function (to, from, next) {
    var title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  });

  _vue2.default.config.productionTip = false;

  // axios
  var axiosConfig = {
    timeout: 20000 // request timeout


    // if (process.env.NODE_ENV !== 'production') {
    //   axiosConfig.baseURL = process.env.BASE_API
    // }
  };var vueInstance = void 0;
  var instance = _axios2.default.create(axiosConfig);
  // Add a request interceptor
  instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    // vueInstance.$Spin.show()
    var token = common.getStoreData('token');
    if (typeof token === 'string') {
      config.headers['Authorization'] = token;
    }
    return config;
  }, function (error) {
    // Do something with request error
    // vueInstance.$Spin.hide()
    return _promise2.default.reject(error);
  });

  // Add a response interceptor
  instance.interceptors.response.use(function (response) {
    // Do something with response data
    // vueInstance.$Spin.hide()
    return response;
  }, function (error) {
    // Do something with response error
    // vueInstance.$Spin.hide()
    return _promise2.default.reject(error);
  });
  _vue2.default.prototype.$http = instance;
  _vue2.default.prototype.$commonact = {
    info: function info(message) {
      vueInstance.$Modal.info({
        title: '提示',
        content: '<p>' + message + '</p>'
      });
    },
    success: function success(message) {
      vueInstance.$Modal.success({
        title: '成功',
        content: '<p>' + message + '</p>'
      });
    },
    warning: function warning(message) {
      vueInstance.$Modal.warning({
        title: '警告',
        content: '<p>' + message + '</p>'
      });
    },
    error: function error(message) {
      vueInstance.$Modal.error({
        title: '错误',
        content: '<p>' + message + '</p>'
      });
    },
    confirm: function confirm(message, cb) {
      vueInstance.$Modal.confirm({
        title: '确认',
        content: '<p>' + message + '</p>',
        onOk: cb
      });
    },
    fault: function fault(error) {
      var response = error.response;
      if (response) {
        if (response.status > 699 && response.status < 800) {
          vueInstance.$Modal.error({
            title: '错误',
            content: '<p>' + response.data.msg + '</p>'
          });
        } else if (response.status === 404) {
          vueInstance.$Modal.error({
            title: '错误',
            content: '<p>未知接口</p>'
          });
        } else if (response.status === 401) {
          if (response.data.errno === -2) {
            vueInstance.$router.push({ path: '/error', query: { httpcode: response.status, error: response.data.errno, message: '从其他地方登录' } });
          } else {
            vueInstance.$router.push({
              path: '/error',
              query: { httpcode: response.status, error: response.data.errno, message: '未经授权：访问由于凭据无效被拒绝' }
            });
          }
        } else {
          vueInstance.$Modal.error({
            title: '错误',
            content: '<p>' + response.data.msg + '</p>'
          });
          // vueInstance.$router.push({ path: '/error', query: { httpcode: response.status, error: response.data.errno, message: response.data.msg } })
        }
      }
    }
  };

  vueInstance = new _vue2.default({
    render: function render(h) {
      return h(_App2.default);
    },
    router: router,
    store: _store2.default
  }).$mount('#app');
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "NhKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js__ = __webpack_require__("x+je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavList_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "QLHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/SidebarNavList.vue?vue&type=template&id=502c35a2
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menu.sub_menu)?_c('li',{staticClass:"has-sub",class:{ 'active': _vm.subIsActive(_vm.menu.sub_menu) }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.expand()}}},[(_vm.menu.badge)?_c('span',{staticClass:"badge pull-right"},[_vm._v(_vm._s(_vm.menu.badge))]):_c('b',{staticClass:"caret"}),_vm._v(" "),(_vm.menu.menu_icon)?_c('i',{class:_vm.menu.menu_icon}):_vm._e(),_vm._v(" "),(_vm.menu.img)?_c('div',{staticClass:"icon-img"},[_c('img',{attrs:{"src":_vm.menu.img,"alt":""}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.menu.menu_name))]),_vm._v(" "),(_vm.menu.highlight)?_c('i',{staticClass:"fa fa-paper-plane text-theme m-l-5"}):_vm._e(),_vm._v(" "),(_vm.menu.label)?_c('span',{staticClass:"label label-theme m-l-5"},[_vm._v(_vm._s(_vm.menu.label))]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"sub-menu",class:{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' },style:({ marginTop: (_vm.pageOptions.pageSidebarMinified) ? - 40 + 'px' : '' })},[_vm._l((_vm.menu.sub_menu),function(submenu){return [_c('sidebar-nav-list',{key:submenu.menu_name,ref:"sidebarNavList",refInFor:true,attrs:{"menu":submenu},on:{"collapse-other":function($event){return _vm.handleCollapseOther(submenu)}}})]})],2)]):_c('router-link',{attrs:{"to":_vm.menu.menu_path,"active-class":"active","tag":"li"},nativeOn:{"click":function($event){return _vm.collapseOther()}}},[_c('a',[(_vm.menu.badge)?_c('span',{staticClass:"badge pull-right"},[_vm._v(_vm._s(_vm.menu.badge))]):_vm._e(),_vm._v(" "),(_vm.menu.menu_icon)?_c('i',{class:_vm.menu.menu_icon}):_vm._e(),_vm._v(" "),(_vm.menu.img)?_c('div',{staticClass:"icon-img"},[_c('img',{attrs:{"src":_vm.menu.img,"alt":""}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.menu.menu_name))]),_vm._v(" "),(_vm.menu.highlight)?_c('i',{staticClass:"fa fa-paper-plane text-theme m-l-5"}):_vm._e(),_vm._v(" "),(_vm.menu.label)?_c('span',{staticClass:"label label-theme m-l-5"},[_vm._v(_vm._s(_vm.menu.label))]):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/sidebar/SidebarNavList.vue?vue&type=template&id=502c35a2
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "QTf2":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Xxa5"), __webpack_require__("exGp"), __webpack_require__("bOdI"), __webpack_require__("Cpzh"), __webpack_require__("J2uu")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _regenerator, _asyncToGenerator2, _defineProperty2, _mutationsType, common) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _mutations;

  var state = {
    vesselOptCache: common.getStoreData('vesselopt') || [],
    countryOptCache: common.getStoreData('countryopt') || [],
    portOptCache: common.getStoreData('portopt') || [],
    terminalOptCache: common.getStoreData('terminalopt') || []
  };

  var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationsType.CARGO_SETVC, function (state, vesselInfo) {
    var vo = common.getStoreData('vesselopt') || [];
    if (vo.length > 4) {
      vo.pop();
      vo.unshift(vesselInfo);
    } else {
      vo.unshift(vesselInfo);
    }
    state.vesselOptCache = vo;
    common.setStoreData('vesselopt', vo);
  }), (0, _defineProperty3.default)(_mutations, _mutationsType.CARGO_SETCC, function (state, countryInfo) {
    var co = common.getStoreData('countryopt') || [];
    if (co.length > 4) {
      co.pop();
      co.unshift(countryInfo);
    } else {
      co.unshift(countryInfo);
    }
    state.countryOptCache = co;
    common.setStoreData('countryopt', co);
  }), (0, _defineProperty3.default)(_mutations, _mutationsType.CARGO_SETPC, function (state, portInfo) {
    var po = common.getStoreData('portopt') || [];
    if (po.length > 4) {
      po.pop();
      po.unshift(portInfo);
    } else {
      po.unshift(portInfo);
    }
    state.portOptCache = po;
    common.setStoreData('portopt', po);
  }), (0, _defineProperty3.default)(_mutations, _mutationsType.CARGO_SETTC, function (state, terminalInfo) {
    var to = common.getStoreData('terminalopt') || [];
    if (to.length > 4) {
      to.pop();
      to.unshift(terminalInfo);
    } else {
      to.unshift(terminalInfo);
    }
    state.terminalOptCache = to;
    common.setStoreData('terminalopt', to);
  }), _mutations);

  var actions = {
    setVC: function setVC(_ref, vesselInfo) {
      var _this = this;

      var state = _ref.state,
          commit = _ref.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit(_mutationsType.CARGO_SETVC, vesselInfo);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setCC: function setCC(_ref2, countryInfo) {
      var _this2 = this;

      var state = _ref2.state,
          commit = _ref2.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit(_mutationsType.CARGO_SETCC, countryInfo);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setPC: function setPC(_ref3, portInfo) {
      var _this3 = this;

      var state = _ref3.state,
          commit = _ref3.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit(_mutationsType.CARGO_SETPC, portInfo);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setTC: function setTC(_ref4, terminalInfo) {
      var _this4 = this;

      var state = _ref4.state,
          commit = _ref4.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit(_mutationsType.CARGO_SETTC, terminalInfo);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  };

  exports.default = {
    state: state,
    mutations: mutations,
    actions: actions
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "QaFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js__ = __webpack_require__("Hj8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenuNav_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "Qif7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_5_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_5_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_5_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_style_index_0_id_7d2051fe_scoped_true_lang_css__ = __webpack_require__("Y/xu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_5_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_5_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_5_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_style_index_0_id_7d2051fe_scoped_true_lang_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_5_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_5_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_5_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_style_index_0_id_7d2051fe_scoped_true_lang_css__);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_5_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_5_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_5_3_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_style_index_0_id_7d2051fe_scoped_true_lang_css___default.a); 

/***/ }),

/***/ "ST7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js__ = __webpack_require__("0Ufk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SidebarNavProfile_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "TimX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRXO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaBq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WKTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js__ = __webpack_require__("2LVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TopMenu_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "XSYp":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'Footer',
    data: function data() {
      return {
        pageOptions: _PageOptions2.default
      };
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "Xsvw":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Xxa5"), __webpack_require__("exGp"), __webpack_require__("bOdI"), __webpack_require__("Cpzh"), __webpack_require__("J2uu")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _regenerator, _asyncToGenerator2, _defineProperty2, _mutationsType, common) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var state = {
    vesselOptCache: common.getStoreData('pathvesselopt') || []
  };

  var mutations = (0, _defineProperty3.default)({}, _mutationsType.PATH_SETVC, function (state, vesselInfo) {
    var vo = common.getStoreData('pathvesselopt') || [];
    if (vo.length > 4) {
      vo.pop();
      vo.unshift(vesselInfo);
    } else {
      vo.unshift(vesselInfo);
    }
    state.vesselOptCache = vo;
    common.setStoreData('pathvesselopt', vo);
  });

  var actions = {
    setVC: function setVC(_ref, vesselInfo) {
      var _this = this;

      var state = _ref.state,
          commit = _ref.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit(_mutationsType.PATH_SETVC, vesselInfo);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  };

  exports.default = {
    state: state,
    mutations: mutations,
    actions: actions
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "Y/xu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ys3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YzDh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZFgj":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'Panel',
		props: ['title', 'body', 'footer', 'variant', 'noBody', 'noButton', 'outsideBody', 'bodyClass', 'footerClass', 'panelClass'],
		data: function data() {
			return {
				expand: false,
				collapse: false,
				remove: false,
				reload: false,
				panelTheme: this.variant ? 'panel-' + this.variant : 'panel-inverse'
			};
		},

		computed: {
			hasFooterSlot: function hasFooterSlot() {
				return !!this.$slots.footer;
			},
			hasHeaderSlot: function hasHeaderSlot() {
				return !!this.$slots.header;
			}
		},
		methods: {
			panelExpand: function panelExpand() {
				this.expand = !this.expand;
				this.$emit('expand', this.expand);
			},
			panelCollapse: function panelCollapse() {
				this.collapse = !this.collapse;
			},
			panelRemove: function panelRemove() {
				this.remove = !this.remove;
			},
			panelReload: function panelReload() {
				this.reload = true;
				this.$emit('refresh');
				setTimeout(function () {
					this.resetReload();
				}.bind(this), 2000);
			},
			resetReload: function resetReload() {
				this.reload = false;
			}
		}
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "ZXB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/top-menu/TopMenuNavList.vue?vue&type=template&id=a0b5e38e
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menu.sub_menu)?_c('li',{staticClass:"has-sub",class:{ 'active': _vm.subIsActive(_vm.menu.menu_path) }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.expand()}}},[(_vm.menu.badge)?_c('span',{staticClass:"badge pull-right"},[_vm._v(_vm._s(_vm.menu.badge))]):_c('b',{staticClass:"caret"}),_vm._v(" "),(_vm.menu.menu_icon)?_c('i',{class:'fa ' + _vm.menu.menu_icon}):_vm._e(),_vm._v(" "),(_vm.menu.img)?_c('div',{staticClass:"icon-img"},[_c('img',{attrs:{"src":_vm.menu.img,"alt":""}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.menu.menu_name))]),_vm._v(" "),(_vm.menu.highlight)?_c('i',{staticClass:"fa fa-paper-plane text-theme m-l-5"}):_vm._e(),_vm._v(" "),(_vm.menu.label)?_c('span',{staticClass:"label label-theme m-l-5"},[_vm._v(_vm._s(_vm.menu.label))]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"sub-menu",class:{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' },style:({ marginTop: (_vm.pageOptions.pageSidebarMinified) ? - (_vm.scrollTop + 40) + 'px' : '' })},[_vm._l((_vm.menu.sub_menu),function(submenu){return [_c('top-menu-nav-list',{key:submenu.menu_name,ref:"topMenuNavList",refInFor:true,attrs:{"menu":submenu},on:{"collapse-other":function($event){return _vm.handleCollapseOther(submenu)}}})]})],2)]):_c('router-link',{attrs:{"to":_vm.menu.menu_path,"active-class":"active","tag":"li"},nativeOn:{"click":function($event){return _vm.collapseOther()}}},[_c('a',[(_vm.menu.badge)?_c('span',{staticClass:"badge pull-right"},[_vm._v(_vm._s(_vm.menu.badge))]):_vm._e(),_vm._v(" "),(_vm.menu.icon)?_c('i',{class:'fa ' + _vm.menu.menu_icon}):_vm._e(),_vm._v(" "),(_vm.menu.img)?_c('div',{staticClass:"icon-img"},[_c('img',{attrs:{"src":_vm.menu.img,"alt":""}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.menu.menu_name))]),_vm._v(" "),(_vm.menu.highlight)?_c('i',{staticClass:"fa fa-paper-plane text-theme m-l-5"}):_vm._e(),_vm._v(" "),(_vm.menu.label)?_c('span',{staticClass:"label label-theme m-l-5"},[_vm._v(_vm._s(_vm.menu.label))]):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/top-menu/TopMenuNavList.vue?vue&type=template&id=a0b5e38e
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "Zeja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopMenu_vue_vue_type_template_id_636f77a8__ = __webpack_require__("z2xQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopMenu_vue_vue_type_script_lang_js__ = __webpack_require__("WKTq");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TopMenu_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TopMenu_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TopMenu_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__TopMenu_vue_vue_type_template_id_636f77a8__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TopMenu_vue_vue_type_template_id_636f77a8__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "a9G7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var pageOptions = {
    pageSidebarMinified: false,
    pageContentFullWidth: false,
    pageContentInverseMode: false,
    pageContentFullHeight: false,
    pageWithFooter: false,
    pageWithoutSidebar: false,
    pageWithRightSidebar: false,
    pageWithTwoSidebar: false,
    pageWithWideSidebar: false,
    pageWithLightSidebar: false,
    pageWithTopMenu: false,
    pageSidebarTransparent: false,
    pageMobileSidebarToggled: false,
    pageMobileRightSidebarToggled: false,
    pageMobileTopMenu: false,
    pageMobileMegaMenu: false,
    pageRightSidebarToggled: false,
    pageBodyScrollTop: 0
  };

  exports.default = pageOptions;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "bBfo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer_vue_vue_type_template_id_e434fdce__ = __webpack_require__("tCPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue_vue_type_script_lang_js__ = __webpack_require__("JuyH");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Footer_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Footer_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Footer_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Footer_vue_vue_type_template_id_e434fdce__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Footer_vue_vue_type_template_id_e434fdce__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "cA9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/lib/panel/Panel.vue?vue&type=template&id=7680f018
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.remove)?_c('div',{staticClass:"panel",class:[{ 'panel-expand': _vm.expand, 'panel-loading': _vm.reload }, _vm.panelTheme, _vm.panelClass]},[_c('div',{staticClass:"panel-heading"},[(!_vm.noButton)?_c('div',{staticClass:"panel-heading-btn"},[_c('a',{staticClass:"btn btn-xs btn-icon btn-circle btn-default",attrs:{"href":"javascript:;"},on:{"click":_vm.panelExpand}},[_c('i',{staticClass:"fa fa-expand"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-xs btn-icon btn-circle btn-success",attrs:{"href":"javascript:;"},on:{"click":_vm.panelReload}},[_c('i',{staticClass:"fa fa-redo"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-xs btn-icon btn-circle btn-warning",attrs:{"href":"javascript:;"},on:{"click":_vm.panelCollapse}},[_c('i',{staticClass:"fa fa-minus"})])]):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),(!_vm.hasHeaderSlot)?_c('h4',{staticClass:"panel-title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")]):_vm._e()],2),_vm._v(" "),_vm._t("beforeBody"),_vm._v(" "),(!_vm.noBody)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapse),expression:"!collapse"}],staticClass:"panel-body",class:_vm.bodyClass},[_vm._t("default"),_vm._v(" "),(_vm.reload)?_c('div',{staticClass:"panel-loader"},[_c('span',{staticClass:"spinner-small"})]):_vm._e()],2):_vm._t("default"),_vm._v(" "),_vm._t("outsideBody"),_vm._v(" "),(_vm.hasFooterSlot)?_c('div',{staticClass:"panel-footer",class:_vm.footerClass},[_vm._t("footer")],2):_vm._e(),_vm._v(" "),_vm._t("afterFooter")],2):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/lib/panel/Panel.vue?vue&type=template&id=7680f018
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "cWtX":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Gu7T"), __webpack_require__("Dp6o"), __webpack_require__("MFRW"), __webpack_require__("Amey"), __webpack_require__("d8RH"), __webpack_require__("ghAC"), __webpack_require__("muTo"), __webpack_require__("gEml"), __webpack_require__("nC5D"), __webpack_require__("ukk0")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _toConsumableArray2, _empty, _admin, _map, _customer, _cargo, _baseData, _octopus, _system, _lease) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  var _empty2 = _interopRequireDefault(_empty);

  var _admin2 = _interopRequireDefault(_admin);

  var _map2 = _interopRequireDefault(_map);

  var _customer2 = _interopRequireDefault(_customer);

  var _cargo2 = _interopRequireDefault(_cargo);

  var _baseData2 = _interopRequireDefault(_baseData);

  var _octopus2 = _interopRequireDefault(_octopus);

  var _system2 = _interopRequireDefault(_system);

  var _lease2 = _interopRequireDefault(_lease);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var routes = [{ path: '*', component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XGup")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }, meta: { emptyPage: true } }, { path: '/', component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lmfZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }, meta: { emptyPage: true } }, { path: '/error', component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Zazt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }, meta: { emptyPage: true } }, { path: '/error404', component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XGup")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }, meta: { emptyPage: true } }].concat((0, _toConsumableArray3.default)(_empty2.default), (0, _toConsumableArray3.default)(_admin2.default), (0, _toConsumableArray3.default)(_map2.default), (0, _toConsumableArray3.default)(_customer2.default), (0, _toConsumableArray3.default)(_cargo2.default), (0, _toConsumableArray3.default)(_baseData2.default), (0, _toConsumableArray3.default)(_octopus2.default), (0, _toConsumableArray3.default)(_lease2.default), (0, _toConsumableArray3.default)(_system2.default));

  exports.default = routes;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "caPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarRight_vue_vue_type_template_id_45f3eff6__ = __webpack_require__("opmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarRight_vue_vue_type_script_lang_js__ = __webpack_require__("BSYs");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SidebarRight_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SidebarRight_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SidebarRight_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__SidebarRight_vue_vue_type_template_id_45f3eff6__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SidebarRight_vue_vue_type_template_id_45f3eff6__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "cpFS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8RH":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/customer',
    name: 'customer',
    meta: {
      login: true
    }
  }, { path: '/customer/FeedbackControl', name: 'FeedbackControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("di4R")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/ApplyReport', name: 'ApplyReport', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(62)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KHaX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/DownloadReport', name: 'DownloadReport', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qfLK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/LittleNote', name: 'LittleNote', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YkI3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/VideoInterpretation', name: 'VideoInterpretation', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2vx3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/ActivityConfig', name: 'ActivityConfig', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RYp1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/CetiInterpretation', name: 'CetiInterpretation', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j+iM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/invoiceControl', name: 'invoiceControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("36Zy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/PMManagement', name: 'PMManagement', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(61)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WsSi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/flowtoManagement', name: 'flowtoManagement', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7BMr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/dataBoardManagement', name: 'dataBoardManagement', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iOjp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/dataBoardLog', name: 'dataBoardLog', component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gtGN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/record', name: 'record', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XjQl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/versionNotice', name: 'versionNotice', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("R9Dh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, {
    path: '/customer/userTrialApplication',
    name: 'UserTrialApplication',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("D7ET")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/WorkstationIntroConfig',
    name: 'ProductPresentationSetting',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PeIj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: '/customer/bannerConfig', name: 'bannerConfig', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6BaU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/portNoticeConfig', name: 'portNoticeConfig', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lVtJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/userList', name: 'userList', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EWcv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/userListChannel', name: 'userListChannel', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9B0Z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/customer/potentialUserList', name: 'potentialUserList', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eSY0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, {
    path: '/customer/companyUserApplyList',
    name: 'companyUserApplyList',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kPcJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/postEmail',
    name: 'postEmail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9mB3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/userQueryStatistic',
    name: 'userQueryStatistic',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rnlX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/expendVesselManagement',
    name: 'expendVesselManagement',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(56)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TH4f")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/firstScreenNotify',
    name: 'firstScreenNotify',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5f3i")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/sanctionList',
    name: 'sanctionList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jvlR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/sentimentIndex',
    name: 'sentimentIndex',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mlh2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customer/riskReportManagement',
    name: 'riskReportManagement',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QaX7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "dlx8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g+ak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/SidebarNavProfile.vue?vue&type=template&id=7d2051fe&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-profile"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.expand()}}},[_c('div',{staticClass:"cover with-shadow"}),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.userInfo.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('b',{staticClass:"caret pull-right"}),_vm._v("\n        "+_vm._s(_vm.userInfo.name)+"\n        "),_c('small',[_vm._v("Front end developer")])])])]),_vm._v(" "),_c('li',[_c('ul',{staticClass:"nav nav-profile",class:{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' }},[_c('li',[_c('router-link',{attrs:{"to":"/admin/user/UserProfile","tag":"a"}},[_c('i',{staticClass:"fa fa-cog"}),_vm._v(" Edit Profile\n        ")])],1)])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/sidebar/SidebarNavProfile.vue?vue&type=template&id=7d2051fe&scoped=true
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "gEml":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{ path: '/octopus/OctopusSupplierConfig', name: 'OctopusSupplierConfig', component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EQhA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "ghAC":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/cargo',
    name: 'cargo',
    meta: {
      login: true
    }
  }, { path: '/map/CargoFlowList', name: 'CargoFlowList', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mxh9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/CargoFlowMap', name: 'CargoFlowMap', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1nxu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/VoyageManagement', name: 'VoyageManagement', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("K9wS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/map/VoyageManagementMap', name: 'VoyageManagementMap', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o/gT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/cargo/DrawCargoFlow', name: 'DrawCargoFlow', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dhzN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "hA8f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hQya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopMenuNavList_vue_vue_type_template_id_a0b5e38e__ = __webpack_require__("ZXB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopMenuNavList_vue_vue_type_script_lang_js__ = __webpack_require__("11/W");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TopMenuNavList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TopMenuNavList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TopMenuNavList_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__TopMenuNavList_vue_vue_type_template_id_a0b5e38e__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TopMenuNavList_vue_vue_type_template_id_a0b5e38e__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "jU7J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jcqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=8ccf484c
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.emptyPage)?_c('div',[_c('router-view'),_vm._v(" "),_c('vue-ins-progress-bar')],1):_c('div',{staticClass:"fade page-sidebar-fixed page-header-fixed show page-container",class:{ 
		'page-sidebar-minified': _vm.pageOptions.pageSidebarMinified, 
		'page-content-full-height': _vm.pageOptions.pageContentFullHeight, 
		'page-without-sidebar': _vm.pageOptions.pageWithoutSidebar, 
		'page-with-right-sidebar': _vm.pageOptions.pageWithRightSidebar, 
		'page-with-two-sidebar': _vm.pageOptions.pageWithTwoSidebar,
		'page-with-wide-sidebar': _vm.pageOptions.pageWithWideSidebar,
		'page-with-light-sidebar': _vm.pageOptions.pageWithLightSidebar,
		'page-with-top-menu': _vm.pageOptions.pageWithTopMenu,
		'page-sidebar-toggled': _vm.pageOptions.pageMobileSidebarToggled,
		'page-right-sidebar-toggled': _vm.pageOptions.pageMobileRightSidebarToggled || _vm.pageOptions.pageRightSidebarToggled,
		'has-scroll': _vm.pageOptions.pageBodyScrollTop
	},staticStyle:{"height":"100vh"}},[_c('Header'),_vm._v(" "),(_vm.pageOptions.pageWithTopMenu)?_c('TopMenu'):_vm._e(),_vm._v(" "),(!_vm.pageOptions.pageWithoutSidebar)?_c('Sidebar'):_vm._e(),_vm._v(" "),(_vm.pageOptions.pageWithTwoSidebar)?_c('SidebarRight'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content",class:{ 'content-full-width': _vm.pageOptions.pageContentFullWidth, 'content-inverse-mode': _vm.pageOptions.pageContentInverseMode },staticStyle:{"height":"100%","overflow":"auto"},attrs:{"id":"content"}},[(_vm.forReload)?_c('router-view',{on:{"refresh":_vm.refreshRouter}}):_vm._e(),_vm._v(" "),_c('vue-ins-progress-bar')],1),_vm._v(" "),(_vm.pageOptions.pageWithFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/App.vue?vue&type=template&id=8ccf484c
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "lNZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js__ = __webpack_require__("a9G7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PageOptions_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "muTo":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/baseData',
    name: 'baseData',
    meta: {
      login: true
    }
  }, { path: '/baseData/goodsManage', name: 'goodsManage', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OcBF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/baseData/businessManagement', name: 'businessManagement', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fRD4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "nC5D":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{ path: '/system/WechatResponseConfig', name: 'WechatResponseConfig', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ivRF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "opmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar-right/SidebarRight.vue?vue&type=template&id=45f3eff6
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar sidebar-right",attrs:{"id":"sidebar-right"}},[_c('div',{attrs:{"data-scrollbar":"true","data-height":"100%"}},[_c('ul',{staticClass:"nav m-t-10"},[_c('li',{staticClass:"nav-widget"},[_c('p',[_vm._v("Accordion")]),_vm._v(" "),_c('div',{staticClass:"card-accordion",attrs:{"id":"accordion"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #1\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #2\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #3\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #4\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion4","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion5",modifiers:{"accordion5":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #5\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion5","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion6",modifiers:{"accordion6":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #6\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion6","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion7",modifiers:{"accordion7":true}}],staticClass:"card-header bg-black-darker b-0 text-white pointer-cursor",attrs:{"header-tag":"header"}},[_c('i',{staticClass:"fa fa-plus-circle pull-right text-success"}),_vm._v("\n\t\t\t\t\t\t\t\tAccordion #7\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion7","accordion":"my-accordion"}},[_c('b-card-body',[_vm._v("\n\t\t\t\t\t\t\t\t\tAnim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.\n\t\t\t\t\t\t\t\t")])],1)],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar-bg sidebar-right"})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/sidebar-right/SidebarRight.vue?vue&type=template&id=45f3eff6
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "q9sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/SidebarNav.vue?vue&type=template&id=2883c6a6
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userInfo.menulist)?_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-header"},[_vm._v("Navigation")]),_vm._v(" "),_vm._l((_vm.userInfo.menulist),function(menu){return [_c('sidebar-nav-list',{key:menu.menu_name,ref:"sidebarNavList",refInFor:true,attrs:{"menu":menu,"status":menu.status},on:{"collapse-other":function($event){return _vm.handleCollapseOther(menu)}}})]}),_vm._v(" "),_c('li',[_c('a',{staticClass:"sidebar-minify-btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.handleSidebarMinify()}}},[_c('i',{staticClass:"fa fa-angle-double-left"})])])],2):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/sidebar/SidebarNav.vue?vue&type=template&id=2883c6a6
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "r0H6":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("wnZX"), __webpack_require__("DHpy"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _SidebarNav, _SidebarNavProfile, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SidebarNav2 = _interopRequireDefault(_SidebarNav);

  var _SidebarNavProfile2 = _interopRequireDefault(_SidebarNavProfile);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'Sidebar',
    components: {
      SidebarNav: _SidebarNav2.default,
      SidebarNavProfile: _SidebarNavProfile2.default
    },
    data: function data() {
      return {
        ops: {
          bar: {
            background: '#575d63'
          }
        },
        pageOptions: _PageOptions2.default
      };
    },

    methods: {
      dismissSidebar: function dismissSidebar() {
        this.pageOptions.pageMobileSidebarToggled = false;
        this.pageOptions.pageMobileRightSidebarToggled = false;
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "rJH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js__ = __webpack_require__("D3yc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js___default.a); 

/***/ }),

/***/ "rMHv":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Dd8w"), __webpack_require__("NYxO"), __webpack_require__("wVti"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _extends2, _vuex, _SidebarNavList, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _SidebarNavList2 = _interopRequireDefault(_SidebarNavList);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'SidebarNav',
    components: {
      SidebarNavList: _SidebarNavList2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('access', {
      userInfo: function userInfo(state) {
        return state.userInfo;
      }
    })),
    data: function data() {
      return {
        pageOptions: _PageOptions2.default
      };
    },

    methods: {
      handleCollapseOther: function handleCollapseOther(menu) {
        for (var i = 0; i < this.userInfo.menulist.length; i++) {
          this.$refs.sidebarNavList[i].collapse(menu);
        }
      },
      handleSidebarMinify: function handleSidebarMinify() {
        this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "tCPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/footer/Footer.vue?vue&type=template&id=e434fdce
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v("\n\t© 2018 Color Admin Responsive Admin Template - Sean Ngu All Rights Reserved\n")])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/footer/Footer.vue?vue&type=template&id=e434fdce
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "tObk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/header/Header.vue?vue&type=template&id=ffdc75fc
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header navbar-default",attrs:{"id":"header"}},[_c('div',{staticClass:"navbar-header"},[(_vm.pageOptions.pageWithTwoSidebar)?_c('button',{staticClass:"navbar-toggle pull-right",attrs:{"type":"button"},on:{"click":_vm.toggleMobileRightSidebar}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]):_vm._e(),_vm._v(" "),(_vm.pageOptions.pageWithTwoSidebar)?_c('button',{staticClass:"navbar-toggle pull-left",attrs:{"type":"button"},on:{"click":_vm.toggleMobileSidebar}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/empty/home"}},[_c('span',{},[_c('img',{attrs:{"src":__webpack_require__("9AdH"),"alt":"52hz"}})]),_vm._v(" "),_c('b',[_vm._v("油化52Hz数据管理中台")])]),_vm._v(" "),(!_vm.pageOptions.pageWithTwoSidebar && (!_vm.pageOptions.pageWithTopMenu && !_vm.pageOptions.pageWithoutSidebar))?_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button"},on:{"click":_vm.toggleMobileSidebar}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]):_vm._e(),_vm._v(" "),(_vm.pageOptions.pageWithTopMenu && _vm.pageOptions.pageWithoutSidebar)?_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button"},on:{"click":_vm.toggleMobileTopMenu}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"navbar-nav navbar-right"},[_c('li',{staticClass:"dropdown navbar-user"},[_c('Dropdown',{staticClass:"dropdown-menu-right",attrs:{"trigger":"click"},on:{"on-click":_vm.dropdownWork}},[_c('a',{staticClass:"btn btn-link dropdown-toggle"},[_c('img',{attrs:{"src":_vm.userInfo.avatar,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(_vm._s(_vm.userInfo.name))]),_vm._v(" "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('DropdownMenu',{staticStyle:{"min-width":"10rem"},attrs:{"slot":"list"},slot:"list"},[_c('DropdownItem',{attrs:{"name":"profile"}},[_vm._v("Edit Profile")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":"","name":"logout"}},[_vm._v("Log Out")])],1)],1)],1),_vm._v(" "),(_vm.pageOptions.pageWithTwoSidebar)?_c('li',{staticClass:"divider d-none d-md-block"}):_vm._e(),_vm._v(" "),(_vm.pageOptions.pageWithTwoSidebar)?_c('li',{staticClass:"d-none d-md-block"},[_c('a',{staticClass:"f-s-14",attrs:{"href":"javascript:;","data-click":"right-sidebar-toggled"},on:{"click":_vm.toggleRightSidebar}},[_c('i',{staticClass:"fa fa-th"})])]):_vm._e()])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/header/Header.vue?vue&type=template&id=ffdc75fc
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEtF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopMenuNav_vue_vue_type_template_id_08db4888__ = __webpack_require__("2ofX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopMenuNav_vue_vue_type_script_lang_js__ = __webpack_require__("QaFg");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TopMenuNav_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TopMenuNav_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TopMenuNav_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__TopMenuNav_vue_vue_type_template_id_08db4888__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TopMenuNav_vue_vue_type_template_id_08db4888__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "uk7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel_vue_vue_type_template_id_7680f018__ = __webpack_require__("cA9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Panel_vue_vue_type_script_lang_js__ = __webpack_require__("74aZ");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Panel_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Panel_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Panel_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__Panel_vue_vue_type_template_id_7680f018__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Panel_vue_vue_type_template_id_7680f018__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "ukk0":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = [{
    path: '/lease',
    name: 'lease',
    meta: {
      login: true
    }
  }, { path: '/lease/VesselPSCConfigControl', name: 'VesselPSCConfigControl', component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tld0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }];
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "wVti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNavList_vue_vue_type_template_id_502c35a2__ = __webpack_require__("QLHj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavList_vue_vue_type_script_lang_js__ = __webpack_require__("NhKw");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SidebarNavList_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SidebarNavList_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SidebarNavList_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNavList_vue_vue_type_template_id_502c35a2__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNavList_vue_vue_type_template_id_502c35a2__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "wnZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNav_vue_vue_type_template_id_2883c6a6__ = __webpack_require__("q9sz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNav_vue_vue_type_script_lang_js__ = __webpack_require__("D6JK");
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SidebarNav_vue_vue_type_script_lang_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SidebarNav_vue_vue_type_script_lang_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__("K1/g");





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SidebarNav_vue_vue_type_script_lang_js__["default"],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNav_vue_vue_type_template_id_2883c6a6__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SidebarNav_vue_vue_type_template_id_2883c6a6__["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "x+je":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("wVti"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _SidebarNavList, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SidebarNavList2 = _interopRequireDefault(_SidebarNavList);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'SidebarNavList',
    props: ['menu'],
    components: {
      SidebarNavList: _SidebarNavList2.default
    },
    data: function data() {
      return {
        stat: '',
        pageOptions: _PageOptions2.default
      };
    },

    methods: {
      expand: function expand() {
        if (this.stat === '') {
          this.stat = this.subIsActive(this.menu.path) ? 'collapse' : 'expand';
        } else {
          this.stat = this.stat === 'expand' ? 'collapse' : 'expand';
        }
        this.$emit('collapse-other', this.menu);
      },
      collapse: function collapse(menu) {
        if (this.menu !== menu) {
          this.stat = 'collapse';
        }
      },
      collapseOther: function collapseOther() {
        this.$emit('collapse-other', this.menu);
      },
      handleCollapseOther: function handleCollapseOther(menu) {
        for (var i = 0; i < this.menu.sub_menu.length; i++) {
          this.$refs.sidebarNavList[i].collapse(menu);
        }
      },
      subIsActive: function subIsActive(path) {
        var _this = this;

        var paths = Array.isArray(path) ? path : [path];
        if (path) {
          return paths.some(function (path) {
            return _this.$route.path.indexOf(path.menu_path) === 0;
          });
        }
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "x4wN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("jGjK"), __webpack_require__("6e9x")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _TopMenuNavList, _PageOptions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _TopMenuNavList2 = _interopRequireDefault(_TopMenuNavList);

  var _PageOptions2 = _interopRequireDefault(_PageOptions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    name: 'TopMenuNavList',
    props: ['menu'],
    components: {
      TopMenuNavList: _TopMenuNavList2.default
    },
    data: function data() {
      return {
        stat: '',
        pageOptions: _PageOptions2.default
      };
    },

    methods: {
      expand: function expand() {
        if (this.stat === '') {
          this.stat = this.subIsActive(this.menu.path) ? 'collapse' : 'expand';
        } else {
          this.stat = this.stat === 'expand' ? 'collapse' : 'expand';
        }
        this.$emit('collapse-other', this.menu);
      },
      collapse: function collapse(menu) {
        if (this.menu !== menu) {
          this.stat = 'collapse';
        }
      },
      collapseOther: function collapseOther() {
        this.$emit('collapse-other', this.menu);
      },
      handleCollapseOther: function handleCollapseOther(menu) {
        for (var i = 0; i < this.menu.sub_menu.length; i++) {
          this.$refs.topMenuNavList[i].collapse(menu);
        }
      },
      subIsActive: function subIsActive(path) {
        var _this = this;

        var paths = Array.isArray(path) ? path : [path];
        return paths.some(function (path) {
          return _this.$route.path.indexOf(path) === 0;
        });
      }
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "xm+f":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("Xxa5"), __webpack_require__("exGp"), __webpack_require__("bOdI"), __webpack_require__("Cpzh"), __webpack_require__("J2uu")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (exports, _regenerator, _asyncToGenerator2, _defineProperty2, _mutationsType, common) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _mutations;

  var state = {
    userInfo: common.getStoreData('userinfo') || {}
  };

  var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationsType.ACCESS_LOGIN, function (state, _ref) {
    var userInfo = _ref.userInfo;

    state.userInfo = userInfo;
    common.clearStoreData();
    common.setStoreData('token', userInfo.Authorization);
    common.setStoreData('userinfo', userInfo);
  }), (0, _defineProperty3.default)(_mutations, _mutationsType.ACCESS_LOGOUT, function (state) {
    state.userInfo = {};
    common.clearStoreData();
  }), _mutations);

  var actions = {
    login: function login(_ref2, _ref3) {
      var _this = this;

      var state = _ref2.state,
          commit = _ref2.commit;
      var userInfo = _ref3.userInfo;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit(_mutationsType.ACCESS_LOGIN, {
                  userInfo: userInfo
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    logout: function logout(_ref4) {
      var _this2 = this;

      var state = _ref4.state,
          commit = _ref4.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit(_mutationsType.ACCESS_LOGOUT);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  };

  exports.default = {
    state: state,
    mutations: mutations,
    actions: actions
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "z2xQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/top-menu/TopMenu.vue?vue&type=template&id=636f77a8
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu",class:{ 'd-block': _vm.pageOptions.pageMobileTopMenu },attrs:{"id":"top-menu"}},[_c('top-menu-nav')],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/top-menu/TopMenu.vue?vue&type=template&id=636f77a8
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f9b2a574abcebf5f9e78.js